import React, { Component } from 'react'
import { PageContainer } from '@toolpad/core/PageContainer'
import EmailNotificationTable from '../../../components/admin_portal/email_notification/EmailNotificationTable'
import CreateEmailNotification from '../../../components/admin_portal/email_notification/CreateEmailNotification'
import EmailNotificationPageToolbar from '../../../components/admin_portal/email_notification/EmailNotificationPageToolbar'

export class EmailNotificationContainer extends Component {

    handleEmailNotificationModal = (newVal, c_action) => {
        this.props.setEmailNotificationModalOpen(newVal);
        this.props.setAction(c_action)
    }

    componentDidMount() {
        this.props.get_company_list({ page: 1, limit: 1000 }); // Assuming a large limit to get all for dropdown/lookup
        this.props.get_process_list({ page: 1, limit: 1000 });
        this.props.get_stage_list({ page: 1, limit: 1000 });
    }

    handleEmailNotificationUpdateModal = async (newVal, c_action, data) => {
        if (data) {
            this.props.setSelectedData(data);
            this.props.setId(data.id);
            this.props.setEmailNotificationModalOpen(newVal);
            this.props.setAction(c_action)
        }
    };

    handleEmailNotificationSubmit = async (payload) => {
        let res = await this.props.create_email_notification(payload);
        return res;
    };

    handleEmailNotificationUpdate = async (payload) => {
        let res = await this.props.update_email_notification(payload);
        return res;
    };

    handleActivateDeactivateEmailNotification = async (payload) => {
        let res = await this.props.activate_deactivate_email_notification(payload);
        return res;
    };


    render() {
        const {
            is_email_notification_modal_open,
            common_loading,
            total_email_notification_count,
            active_email_notification,
            page,
            c_action,
            email_notification_id,
            selected_data,
            company_list,
            process_list,
            stage_list
        } = this.props;
        return (
            <PageContainer maxWidth='xl' slots={{
                toolbar: EmailNotificationPageToolbar,
            }} title={""}
                sx={{
                    '& .css-lc31tn > .MuiTypography-h4': {
                        fontSize: '14px',
                        alignSelf: { md: 'center', xs: 'flex-start' },
                    },
                    '& .css-lc31tn': {
                        bgcolor: theme => theme.palette.grey[200],
                        px: 1.5,
                        py: 0.1,
                        borderRadius: '10px',
                        my: 1.5,
                        flexDirection: { md: 'row', xs: 'column' },
                        alignItems: { md: 'unset', xs: 'flex-start' }
                    },
                    '& .css-1hwxlk6': {
                        width: { md: 'unset', xs: '100%' },
                        flexDirection: { md: 'row', xs: 'column' },
                        marginLeft: { md: 'auto', xs: 'unset!important' }
                    },
                }}>
                <EmailNotificationTable
                    total_email_notification_count={total_email_notification_count}
                    is_loading={common_loading}
                    page={page}
                    is_email_notification_modal_open={is_email_notification_modal_open}
                    handleEmailNotificationUpdateModal={this.handleEmailNotificationUpdateModal}
                    activate_deactivate_email_notification={this.handleActivateDeactivateEmailNotification}
                    company_list={company_list}
                    process_list={process_list}
                    stage_list={stage_list}
                />
                <CreateEmailNotification
                    is_email_notification_modal_open={is_email_notification_modal_open}
                    handleEmailNotificationModal={this.handleEmailNotificationModal}
                    handleEmailNotificationSubmit={this.handleEmailNotificationSubmit}
                    handleEmailNotificationUpdate={this.handleEmailNotificationUpdate}
                    is_loading={common_loading}
                    c_action={c_action}
                    email_notification_id={email_notification_id}
                    selected_data={selected_data}
                    company_list={company_list}
                    process_list={process_list}
                    stage_list={stage_list}
                />
            </PageContainer>
        )
    }
}

export default EmailNotificationContainer
